<template>
  <div id="fbButton" class="validacion" v-bind:class="[isForResponsive]" @click="doLogin">

    <span>FACEBOOK</span>
  </div>
</template>

<script>
import { sha256 } from 'js-sha256';
export default {
  name: "FacebookButton",
  data() {
    return {

    };
  },
  props: {
    isForResponsive: null,
  },
  mounted(){
    console.log(process.env)
  },
  methods: {
    doLogin: function () {
      
      var vm = this;
      window.FB.login(
        (response) =>  {
          // console.log('response',response)
          // debugger
          if (response.status === "connected") {
            // const appsecret_proof = this.hmacHash(response.authResponse.accessToken, process.env.VUE_APP_API)
          
            window.FB.api(
              `/me?fields=age_range,email,name`,
              function (meResponse) {
                console.log("🚀 ~ meResponse:", meResponse)
                // console.log(meResponse);
                const xeerpaNeeded = {
                  ...response,
                  age_range: meResponse.age_range,
                  // birthday: meResponse.birthday,
                  email: meResponse.email
                };
                meResponse.age_range
                  ? vm.$emit("fbLogin", xeerpaNeeded)
                  : vm.$emit("noBirthdayInFacebook");
              }
            );
          }
         
        },
        { scope: "public_profile,email,user_age_range,user_likes" }
      );
    },
    hmacHash(userToken, appSecret) {
      const hash = sha256.hmac.create(appSecret)
      const appsecret_proof = hash.update(userToken).hex();
      return appsecret_proof;
    }
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";

#fbButton {
  background-image: url("../assets/boton rojo.png");
  background-position: center center;
  background-size: 100% 100%;
  color: $white-pantone-663c;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2vw;

  padding: 1vw 2.5vw;

  @media (max-width: 500px) {
    font-size: 6vw;
    padding: 2vw 6vw;
    //padding-top: 4vw;
  }

  letter-spacing: 0.2vw;

  &:hover {
    cursor: pointer;
  }

  span {
    margin-top: 0vw;
    //line-height: 50%;
  }
}
</style>